import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import i18n (needs to be bundled ;))
import './i18n';
import {BrowserRouter} from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ErrorBoundary title="L'application a rencontré une erreur critique. Veuillez recharger la page.">
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </ErrorBoundary>
);

// Mesures de performance uniquement en développement
// Pour envoyer vers un endpoint analytics, remplacer console.log par une fonction de reporting
if (process.env.NODE_ENV !== 'production') {
    reportWebVitals(console.log);
}
